import isMobile from '../common/is-mobile.js';
import isUa from '../common/is-ua.js';

let target = document.querySelector('.top-about .top-about-unit__detail-header');

let html = document.querySelector('.top-about-unit__image');

if(isUa().Mobile) {
  target.after(html)
}